"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
/**
 * Returns a promise which will resolve after the provided number of milliseconds.
 *
 * @param timeout - resolve timeout in milliseconds
 * @internal
 */
function delay(timeout) {
    if (timeout === void 0) { timeout = 0; }
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve();
        }, timeout);
    });
}
exports.delay = delay;
//# sourceMappingURL=testUtils.js.map